
import Vue from 'vue';
import OpenSourceApiCard from './OpenSourceApiCard.vue';
import { OPEN_SOURCE_API_CARDS, OPEN_SOURCE_API_GUIDE_URL, OpenSourceApiCardData } from './openSourceApiCatalog';

export default Vue.extend({
	name: 'OpenSourceApiSection',
	components: {
		OpenSourceApiCard,
	},
	computed: {
		cards (): OpenSourceApiCardData[] {
			return OPEN_SOURCE_API_CARDS;
		},
		// Same RunDiffusion guide is the primary CTA on every card.
		guideUrl (): string {
			return OPEN_SOURCE_API_GUIDE_URL;
		},
	},
});
